import React from "react";
import { useQuoteContext } from "../../../context-api/quote-context";
import { Link } from "react-router-dom";
import { useNavContext } from "../../../context-api/nav-context";
import { boilerPositionData } from "../utils/boilerPositionData";

const QuestFour = () => {
  const { boilerLocationClick } = useQuoteContext();
  const { closeNavbarMenu } = useNavContext();
  return (
    <section
      className="questions-section section-wrapper"
      onMouseOver={closeNavbarMenu}
    >
      <div className="question-header">
        <h1 className="quote-question-title">
          What's The Location Of Your Boiler?
        </h1>
      </div>
      <div className="question-card-section">
        {boilerPositionData.map((item, index) => {
          const { title, image } = item;
          return (
            <Link
              className="question_link"
              key={index}
              to="/question-five"
              onClick={() => boilerLocationClick(title)}
            >
              <div className="question-card">
                <div className="question-card-img">
                  <img src={image} alt={title} />
                </div>
                <div className="question-card-text">
                  <h5 className="subtitle question_subtitle">{title}</h5>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default QuestFour;
